export type BoundingBox = {
  top: number;
  left: number;
  width: number;
  height: number;
};

export type PercentageRect = {
  pctEndX: number;
  pctEndY: number;
  pctStartX: number;
  pctStartY: number;
};

export type DrawRect = {
  endX: number;
  endY: number;
  startX: number;
  startY: number;
};

export type DrawRectFunction = (params: { rect: DrawRect; context: CanvasRenderingContext2D }) => void;

export type Point = {
  x: number;
  y: number;
};

export type PercentagePoint = {
  pctX: number;
  pctY: number;
};

export type BaseMouseEvent = {
  clientX: number;
  clientY: number;
};

export type BoundingBoxAvatarDirection = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

export const getHorizontalOpposite = (position: BoundingBoxAvatarDirection): BoundingBoxAvatarDirection => {
  switch (position) {
    case 'top-left':
      return 'top-right';
    case 'top-right':
      return 'top-left';
    case 'bottom-left':
      return 'bottom-right';
    case 'bottom-right':
      return 'bottom-left';
  }
};
